import { InputIcon, InputOptions, NullableTextInput } from '@tempots/beatui'

export function LooseUrlInput(options: InputOptions<string | null>) {
  return NullableTextInput({
    before: InputIcon({ icon: 'line-md:link' }),
    placeholder: 'example.com',
    ...options,
  })
}
